<script setup>
const { eligibility, event } = defineProps({
  eligibility: Object,
  event: Object,
})

const emit = defineEmits(['close', 'update'])

const { t } = useI18n()

const step = ref(undefined)

const isCustomerAttending = computed(() => event?.customer_attending)

async function cancel() {
  step.value = 'leave-class'
}
</script>

<template>
  <BookingModalLeaveClass
    v-if="step === 'leave-class'"
    :event="event"
    is-room-rental
    @cancel="step = undefined"
    @update="emit('update')"
    @close="emit('close')"
  />
  <div
    v-else
    class="flex grow flex-col justify-between flex-gap-y-4 whitespace-pre-wrap"
  >
    <template v-if="isCustomerAttending">
      <DSAlert
        type="success"
        no-close
        class="w-100%"
      >
        {{ t('You\'ve rented this room') }}
      </DSAlert>
      <div class="flex flex-col items-center flex-gap-y-2">
        <DSAsyncButton
          class="btn btn-md w-full truncate uppercase btn-fill-tertiary"
          @submit="cancel()"
        >
          <span>{{ t('Leave Room Rental') }}</span>
        </DSAsyncButton>
      </div>
    </template>
    <template v-else>
      <DSAlert
        type="danger"
        no-close
        class="w-100%"
      >
        {{ t('This room is full') }}.
      </DSAlert>
    </template>
  </div>
</template>

<i18n>
{
  "en-us": {
    "You've rented this room": "You've rented this room",
    "Leave Room Rental": "Leave Room Rental",
    "This room is full": "This room is full",
    "You have rented the room": "You have rented the room"
  }
}
</i18n>
